import { css } from "@emotion/react";
import { FONTS, fontSize } from "../../../styles/fonts";
import styled from "@emotion/styled";

const textStyles = [
  FONTS.SwarovskiFutura500,
  fontSize.x2,
  css`
    color: var(--secondary-text-color);
  `,
];
export const Text = styled.span(textStyles);
